module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/DJ-d06f0beacce4bc0de22a704c107c6bb1.png";